import React from 'react';

export function TreasureMapToolbar({
  visibleCount = 0,
  categories = [],
  filters,
  viewMode = 'map',
  activeFilterCount = 0,
  canAddLocation = false,
  onQueryChange,
  onCategoryChange,
  onToggleNearby,
  onToggleLootable,
  onToggleDonationsOnly,
  onViewModeChange,
  onToggleFilterPanel,
  onToggleAddLocationForm,
}) {
  const safeFilters = filters || {};
  const safeCategories = Array.isArray(categories) ? categories : [];

  return (
    <div className="treasure-map-toolbar">
      <div className="treasure-map-toolbar__top">
        <div className="treasure-map-toolbar__search">
          <input
            type="search"
            value={safeFilters.query || ''}
            onChange={(event) => onQueryChange?.(event.target.value)}
            placeholder="Ort, Beschreibung oder Kategorie suchen"
            aria-label="Schatzkarte durchsuchen"
          />
        </div>

        <div className="treasure-map-toolbar__actions">
          <button
            type="button"
            className={`treasure-map-toolbar__pill ${safeFilters.layers?.donation !== false && safeFilters.layers?.location === false && safeFilters.layers?.bottle_message === false ? 'is-active' : ''}`}
            onClick={onToggleDonationsOnly}
          >
            ♻️ Nur Pfandspenden
          </button>

          <button
            type="button"
            className={`treasure-map-toolbar__pill ${safeFilters.nearbyOnly ? 'is-active' : ''}`}
            onClick={onToggleNearby}
          >
            📍 Nur in der Nähe
          </button>

          <button
            type="button"
            className={`treasure-map-toolbar__pill ${safeFilters.lootableOnly ? 'is-active' : ''}`}
            onClick={onToggleLootable}
          >
            💰 Nur lootbar
          </button>

          <button
            type="button"
            className={`treasure-map-toolbar__pill ${activeFilterCount > 0 ? 'is-active' : ''}`}
            onClick={onToggleFilterPanel}
          >
            ⚙️ Filter {activeFilterCount > 0 ? `(${activeFilterCount})` : ''}
          </button>

          <div className="treasure-map-toolbar__view-switch" role="tablist" aria-label="Ansicht wechseln">
            <button
              type="button"
              className={viewMode === 'map' ? 'is-active' : ''}
              onClick={() => onViewModeChange?.('map')}
            >
              🗺️ Karte
            </button>
            <button
              type="button"
              className={viewMode === 'list' ? 'is-active' : ''}
              onClick={() => onViewModeChange?.('list')}
            >
              📋 Liste
            </button>
          </div>

          <button
            type="button"
            className={`treasure-map-toolbar__add ${canAddLocation ? '' : 'is-disabled'}`}
            onClick={onToggleAddLocationForm}
          >
            {canAddLocation ? '🆕 Ort hinzufügen' : '🔒 Ort hinzufügen ab Level 5'}
          </button>
        </div>
      </div>

      <div className="treasure-map-toolbar__bottom">
        <div className="treasure-map-toolbar__meta">
          Sichtbar: <strong>{visibleCount}</strong>
        </div>

        <div className="treasure-map-toolbar__chips">
          <button
            type="button"
            className={`treasure-map-toolbar__chip ${safeFilters.activeCategory === 'all' ? 'is-active' : ''}`}
            onClick={() => onCategoryChange?.('all')}
          >
            Alle Kategorien
          </button>

          {safeCategories.map((category) => (
            <button
              type="button"
              key={category.key || category.name || category.label}
              className={`treasure-map-toolbar__chip ${safeFilters.activeCategory === category.key ? 'is-active' : ''}`}
              onClick={() => onCategoryChange?.(category.key)}
            >
              {category.label || category.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TreasureMapToolbar;
